import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Sign In", -1)
const _hoisted_2 = { class: "form__input-description" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Forgot your password? Reset it ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("here")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sign in ")
const _hoisted_7 = { class: "form__message" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Don't have an account? ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Sign up")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(". ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_button = _resolveComponent("loading-button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _createVNode(_component_base_input, {
      class: "full-width",
      placeholder: "Email",
      error: _ctx.signInErrors.emailError,
      modelValue: _ctx.email,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
      modelModifiers: { trim: true }
    }, null, 8, ["error", "modelValue"]),
    _createVNode(_component_base_input, {
      autocomplete: "true",
      class: "full-width",
      placeholder: "Password",
      type: "password",
      error: _ctx.signInErrors.passwordError,
      modelValue: _ctx.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
      modelModifiers: { trim: true }
    }, null, 8, ["error", "modelValue"]),
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        class: "anchor--primary",
        to: "/reset-password"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5
    ]),
    _withDirectives(_createElementVNode("p", { class: "form__error" }, _toDisplayString(_ctx.formError), 513), [
      [_vShow, _ctx.formError]
    ]),
    _createVNode(_component_loading_button, {
      "button-type": "button--inverted",
      loading: _ctx.loading
    }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    }, 8, ["loading"]),
    _createElementVNode("p", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_router_link, {
        class: "anchor--primary",
        to: "/signup"
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _hoisted_10
    ])
  ], 32))
}